import { existsSync } from 'node:fs';
import { join } from 'node:path';
import { useCallback } from 'react';
import { composeValidations, useValidation } from './common.js';

const DATA_COLLECTION_NAME_REGEX = /^[A-Za-z0-9_-]{1,36}$/;

function createDataCollectionNameValidation(projectFolder: string) {
  return composeValidations([
    [
      (value: string) => DATA_COLLECTION_NAME_REGEX.test(value),
      'Collection name must be 1-36 characters and can only contain letters, numbers, underscores, and hyphens.',
    ],
    [
      (value: string) => !existsSync(join(projectFolder, `${value}.ts`)),
      'Collection name must be unique, please choose a name that has not been used yet in your application.',
    ],
  ]);
}

export const useDataCollectionNameValidation = (projectFolder: string) => {
  const validation = useValidation(
    createDataCollectionNameValidation(projectFolder)
  );

  return useCallback(validation, [validation, projectFolder]);
};
